import React from "react";
import { Box } from "../../primitives";
import { FormWrapperProps } from "./FormWrapper.types";

export const FormWrapper: React.FC<FormWrapperProps> = ({
  children,
  onSubmit,
  isDisabled,
  isLoading,
  isFormContainer = true,
  formProps,
  className,
  ...rest
}) => {
  const shouldDisableForm = isDisabled || isLoading;

  return (
    <Box
      className={[
        "w-full",
        shouldDisableForm ? "relative" : undefined,
        className
      ]}
      {...rest}
    >
      {isFormContainer ? (
        <form
          noValidate
          className="h-full"
          onSubmit={(e) => {
            e.stopPropagation();
            e.preventDefault();

            if (onSubmit) {
              onSubmit(e);
            }
          }}
          {...formProps}
        >
          <fieldset disabled={shouldDisableForm} className="h-full">
            {children}
          </fieldset>
        </form>
      ) : (
        <fieldset disabled={shouldDisableForm} className="h-full">
          {children}
        </fieldset>
      )}
      {shouldDisableForm && (
        <Box
          className={"absolute inset-0 z-index-overlay bg-white opacity-40"}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        />
      )}
    </Box>
  );
};
